export const customerTypes = {
    undefined: 'undefined',
    admin: 'admin',
    instructor: 'instructor',
    user: 'user',
    student: 'student',
}
